// src/pages/WelcomePage.jsx
import React from 'react';
import HeroSection from "../../components/Ielts_test/welcome/HeroSection";
import CategorySection from "../../components/Ielts_test/welcome/CategorySection";
import InstructionSection from "../../components/Ielts_test/welcome/InstructionSection";

const WelcomePage = () => {
  return (
    <div className="min-h-screen bg-custom-bg">   
      <HeroSection />
      <CategorySection />
      <InstructionSection />

      {/* Footer kamu */}
    </div>
  );
};

export default WelcomePage;